import { useView } from '../app/use-view.ts'
import { dayText } from '../i18n/dates.ts'
import { useLocale, useT } from '../i18n/index.ts'
import { formatOsTime } from '../os/clock.ts'
import styles from './hud-clock.module.css'
import { NotificationBanners } from './notification-banners.tsx'
import type { Banner } from './use-notifications.ts'
import { WalletBadge } from './wallet-badge.tsx'

/**
 * The top right corner: the game's day and time of day from the sky's clock (`view.os`),
 * "Mon · Week 1" small above `HH:MM`, the balance under them (`WalletBadge`), and Wassup's
 * banners under that. The clock is gone in a level without a sky; the balance stays. On touch
 * the corner moves under the Skip button while that shows.
 */
export function HudClock({ banners }: { readonly banners: readonly Banner[] }) {
  const t = useT()
  const locale = useLocale()
  const minutes = useView((view) => view.os.time)
  const day = useView((view) => view.os.day)
  const touch = useView((view) => view.input.device === 'touch')
  const skip = useView((view) => view.hud.skip !== null)

  return (
    <div class={styles.corner} data-lowered={(touch && skip) || undefined}>
      {minutes !== null && (
        <p class={styles.clock}>
          {day !== null && <span class={styles.day}>{t(dayText(locale, day))}</span>}
          <time class={styles.time}>{formatOsTime(minutes)}</time>
        </p>
      )}
      <WalletBadge />
      <NotificationBanners banners={banners} />
    </div>
  )
}
